<div class="p-a-xl">
    <h2>Cipo Select Fields</h2>

    <div fxLayout="row wrap" fxLayoutGap="12px">
        @for (control of form.controls | keyvalue; track $index) {
            <div fxFlex="30" fxFlexAlign="end" class="m-t">
                <cipo-select [control]="control.value" [fieldData]="fieldDataMap[control.key]()" />
            </div>
        }
    </div>
</div>
